import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Heading, HeadingLevel } from '../../../subcomponents/heading/heading';
export const MemberJourneyListJourneyDetail = observer(props => {
    const { heading, detail, detailId } = props;
    const b = bemClassBuilder('v-member-journey-list-journey-detail');
    return (_jsxs(_Fragment, { children: [_jsx(Heading, Object.assign({ level: HeadingLevel.H4, className: b.element('heading', { [detailId]: true }) }, { children: heading })), _jsx("p", Object.assign({ className: b.element('detail', { [detailId]: true }) }, { children: detail }))] }));
});
MemberJourneyListJourneyDetail.displayName = 'MemberJourneyListJourneyDetail';
